module.exports = __webpack_public_path__ + "img/jolil.a7717a7c.jpg";